export default function ucFirst(str) {
  return str[0].toUpperCase() + str.substring(1);
}



/** WEBPACK FOOTER **
 ** ./lib/helpers/ucFirst.js
 **/